// extracted by mini-css-extract-plugin
export default {"root":"entries_counter-module___root___fe3968c4"};